






























































import { Vue, Component, Prop } from 'vue-property-decorator';
import ChevronIcon from 'mdi-vue/ChevronRight';
import numberFormat from '@/libs/numberFormat';
import Loader from '@/components/Loader.vue';

interface Option {
  value: string;
  label: string;
}
@Component({
  components: {
    ChevronIcon,
    Loader,
  },
})
export default class SummaryBox extends Vue {
  @Prop(Number) total!: number;
  @Prop(Object) value!: Option;
  @Prop({ type: Array, default: () => [] }) options!: Option[];
  @Prop(String) text!: string;
  @Prop(Boolean) loading!: boolean;
  @Prop(Boolean) failed!: boolean;
  @Prop({ type: String, default: 'amount' }) type!: string;
  @Prop({ type: String, default: '' }) currency!: string;

  showOptions = false;

  toggleShowOptions() {
    this.showOptions = !this.showOptions;
  }

  setValue(value: Option) {
    this.$emit('input', value);
    this.showOptions = false;
  }

  get formattedValue() {
    return (this.total < 0 ? '(' : '') + this.currency + (this.currency !== '' ? ' ' : '')
      + numberFormat(Math.abs(this.total)) + (this.total < 0 ? ')' : '');
  }
}
